export default (main, ...mixins) => mixins.reduce(
  (parent, mixin) => mixin(parent),
  main,
);

export { default as Injectable } from './Injectable';
export { default as AsyncState } from './AsyncState';
